import React from "react";
import UniversalLinkButton from "./UniversalLinkButton";

function LegUpSection() {
  return (
    <section
      className="Index-page"
      data-edit-main-image="Background"
      style={{ background: "white", color: "#E27264" }}
    >
      <div className="Index-page-content sqs-alternate-block-style-container">
        <div className="sqs-layout sqs-grid-12 columns-12" data-type="page">
          <div className="row sqs-row">
            <div className="col sqs-col-12">
              <div
                className="row sqs-row"
                style={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div className="col sqs-col-6">
                  <div style={{ maxWidth: 600, fontSize: 24 }}>
                    Give your child a head start on their lifelong math journey
                    with our engaging algebra adventure—designed to build a
                    solid foundation and boost confidence in tackling
                    challenging concepts.
                  </div>
                </div>
                <div className="col sqs-col-6">
                  <div className="sqs-block image-block sqs-block-image sqs-text-ready">
                    <div
                      className="sqs-block-content"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <UniversalLinkButton
                        variant="solid"
                        colour="red"
                        size="large"
                        to="/signup/"
                      >
                        Get Started
                      </UniversalLinkButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LegUpSection;
